import React from 'react';
import PropTypes from 'prop-types';

import Lease from './lease';
import Sale from './sale';

export default function CompSorting({ sort, type, onChange }) {
  const TypeSorting = type === 'lease' ? Lease : Sale;
  return <TypeSorting sort={sort} onChange={onChange} />;
}

CompSorting.propTypes = {
  sort: PropTypes.string,
  type: PropTypes.oneOf(['lease', 'sale']).isRequired,
  onChange: PropTypes.func,
};
